"use client";

import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";
import { useMemo } from "react";

import { cn } from "@/lib/utils";

import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";

import { type BannerProps } from "./banner/banner";
import { NavbarDesktop } from "./navbar-desktop";
import { NavbarMobile } from "./navbar-mobile";

/**
 * The main Navbar component.
 * It fetches navigation data and renders the appropriate
 * desktop or mobile version based on screen size.
 */
export function Navbar() {
  const t = useTranslations("staticComponents.navbar");
  const pathname = usePathname();
  const isHomePage = pathname === "/pl" || pathname === "/en" || pathname === "/uk";

  // Fetch and build the navigation configuration once.
  const items = useMemo(() => {
    const banner = (id: string) =>
      t.has(`${id}.banner`)
        ? (t.raw(`${id}.banner`) as BannerProps)
        : undefined;

    return {
      forKids: {
        trigger: t("forKids.trigger"),
        links: t.raw("forKids.links"),
        banner: banner("forKids"),
      },
      forAdults: {
        trigger: t("forAdults.trigger"),
        links: t.raw("forAdults.links"),
        banner: banner("forAdults"),
      },
      forStudents: {
        trigger: t("forStudents.trigger"),
        links: t.raw("forStudents.links"),
        banner: banner("forStudents"),
      },
      forSchools: {
        trigger: t("forSchools.trigger"),
        links: t.raw("forSchools.links"),
        banner: banner("forSchools"),
      },
      forCompanies: {
        trigger: t("forCompanies.trigger"),
        links: t.raw("forCompanies.links"),
        banner: banner("forCompanies"),
      },
      attractions: {
        trigger: t("attractions.trigger"),
        links: t.raw("attractions.links"),
        banner: undefined,
      },
      contactLabel: t("contact"),
    } as const;
  }, [t]);

  return (
    <header
      className={cn(
        "absolute inset-x-0 z-50",
        isHomePage ? "top-0 lg:top-6" : "top-0",
      )}
    >
      <div className="mx-auto max-w-6xl px-6 py-2">
        {/* Render both and let their internal CSS handle visibility */}
        {/* <div className="opacity-0">
          <LanguageSwitcher isMobile />
        </div> */}
        <div className="">
          <NavbarDesktop items={items} />
          <NavbarMobile items={items} />
          {/* <div className="flex items-center justify-center text-center">
            <LanguageSwitcher isMobile />
          </div> */}
        </div>
      </div>
    </header>
  );
}
